import './adrienn/style';
import FormStructure from './adrienn/form_structure';

export default FormStructure;